/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/components/editors/state" />

export const Validating = "validating";
export const InValid = "invalid";
export const Valid = "valid";